import React, {Component} from 'react';
import {browserHistory, hashHistory} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {registerUser, updateUser, sendEmailVerification} from '../../actions/firebase_actions';
import {updateModal} from '../../actions/modal.js';
import {clearDraw} from '../../actions/ts_overlay_actions';
import Menu from '../menu/';
import Privacy from '../documents/privacy/';
import Terms from '../documents/terms/';
import License from '../documents/license/';
import Login_Register from '../login_register/';
import {Checkbox, Panel, Button} from 'react-bootstrap';
class UserRegister extends Component {
  constructor(props) {
    super(props);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.state = {
      message: '',
      success: '',
      legalDoc:'terms',
      agree:'no',
      open1: true,
      open2: false,
      open3: true
    };
  }

  updateProfile(email, displayName) {
    var {currentUser} = this.props;
    this.props.updateUser({email, displayName}).then((data) => {
      if (data.payload.errorCode) {
        this.setState({message: data.payload.errorMessage});
      } else {
        this.props.sendEmailVerification({email, displayName}).then((data) => {
          if (data.payload.errorCode) {
            this.setState({message: data.payload.errorMessage, success: ""});
          } else {
            this.setState({message: "", success: "Verification email sent. Please verify before logging in.",open1:false,open2:false,open3:false});
            //hashHistory.replace('/home');
            //dispatch(updateModal(false,null));
            //this.props.updateModal(true,<Login_Register/>);
            //Thanks for signing up! Please verify your email before logging in.
          }
        });
      }
    });
  }

  onFormSubmit(event) {
    event.preventDefault();
    var {overlay} = this.props;
    const email = this.refs.email.value;
    const password = this.refs.password.value;
    const displayName = this.refs.displayName.value;
    if (this.state.agree != 'yes')
    {
        this.setState({message: "You must agree to Terms of Use and License Agreement."});
        return;
    }
    this.props.registerUser({email, password}).then((data) => {
      if (data.payload.errorCode) {
        this.setState({message: data.payload.errorMessage});
      } else {
        this.updateProfile(email, displayName);
        //hashHistory.replace('/home');
        //browserHistory.push('/profile');
      }
    });
  }

  handleEnter(event) {
    if (event.keyCode === 13) {
      const form = event.target.form;
      const index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index + 1].focus();
      form.elements[index].blur();
      event.preventDefault();
    }
  }

  handleFocusOut(event) {
      const form = event.target.form;
      const index = Array.prototype.indexOf.call(form, event.target);
      form.elements[index].blur();
      event.preventDefault();
  }

  render() {
    var legalBox;
    var termsStyle;
    var licenseStyle;
    if (this.state.legalDoc == 'terms')
    {
      legalBox = <Terms boxStyle={"scrollBoxSmallDiv"}/>
      termsStyle = "titleText";
      licenseStyle = "titleTextGray pointerCursor";
    }
    if (this.state.legalDoc == 'license')
    {
      legalBox = <License boxStyle={"scrollBoxSmallDiv"}/>
        termsStyle = "titleTextGray pointerCursor";
        licenseStyle = "titleText";
    }
    var agreeIcon;
    var agreeText;
    if (this.state.agree == 'no')
    {
    agreeIcon = "fa fa-square";
    agreeText = "blueBoldText pointerCursor";
    }
    if (this.state.agree == 'yes')
    {
    agreeIcon = "fa fa-check ";
    agreeText = "whiteBoldText";
    }
    var buttonText = "Next";
    if(!this.state.open1)
    {
      buttonText = "Back";
    }
    return (
      <div>
        <Panel bsClass={false} collapsible expanded={this.state.open3}>
        <form id="frmRegister" role="form" onSubmit={this.onFormSubmit}>
          <Panel bsClass={false} collapsible expanded={this.state.open1}>
            <p className="errorText">
              {this.state.message}
            </p>
            <p className="successText">
              {this.state.success}
            </p>
          {/* <span className="headerText">Register</span> */}
          <div className="form-group">
            <label className="titleText" htmlFor="txtRegEmail">Email Address</label>
            <input onfocusout={this.handleFocusOut} onKeyDown={this.handleEnter} type="email" className="form-control inputText" ref="email" id="txtEmail" placeholder="Email" name="email"/>
          </div>
          <div className="form-group">
            <label className="titleText" htmlFor="txtRegPass">Password</label>
            <input onfocusout={this.handleFocusOut} onKeyDown={this.handleEnter} type="password" className="form-control inputText" ref="password" id="txtPass" placeholder="Password" name="password"/>
          </div>
          <div className="form-group">
            <label htmlFor="displayName" className="titleText">Gaming Handle (optional)</label>
            <input onfocusout={this.handleFocusOut} onKeyDown={this.handleEnter} type="text" maxLength="20" className="form-control inputText" ref="displayName" id="displayName" placeholder="Gaming handle" name="displayName"/>
          </div>
        </Panel>
            <div className="form-group">
          <button type="button" className="buttonStyle" onClick={ ()=> this.setState({ open2: !this.state.open2, open1: !this.state.open1 })}>
       {buttonText}
     </button>
          </div>
          <Panel bsClass={false} collapsible expanded={this.state.open2}>
            <p className="errorText">
              {this.state.message}
            </p>
            <p className="successText">
              {this.state.success}
            </p>
          <div className="form-group">
            <label className={termsStyle} onClick={(event) => {this.setState({legalDoc: 'terms'})}}>Terms of Use</label> | <label className={licenseStyle} onClick={(event) => {this.setState({legalDoc: 'license'})}}>License Agreement</label>
            {legalBox}
            <br/>
          <label className={agreeText} onClick={() => {this.setState({agree: 'yes'})}}><i className={agreeIcon}></i> I have read and agree to the Terms of Use and License Agreement.</label>
          </div>
            <div className="form-group">
          <button type="submit" name="submit" id="submit" className="buttonStyle">Register</button>
          </div>
        </Panel>
                </form>
        </Panel>
              <div className="form-group">
            <p className="errorText">
              {this.state.message}
            </p>
            <p className="successText">
              {this.state.success}
            </p>
          </div>
            <br/>
      </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    registerUser,
    updateUser,
    updateModal,
    clearDraw,
    sendEmailVerification
  }, dispatch);
}

function mapStateToProps(state) {
  return {currentUser: state.currentUser, overlay: state.overlay};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRegister);



// WEBPACK FOOTER //
// ./src/app/components/register/index.jsx